import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralButtonsButtonDayLiveshopSignature {
  Args: {
    isDayLiveupdateLimitReached?: boolean;
    isUpdating?: boolean;
    isVisible?: boolean;
    startDayLiveupdate: () => void;
  };
}

const GeneralButtonsButtonDayLiveshop = <template>
  {{#if @isUpdating}}
    <div class="spinning ml-100">
      <PrismIcon @name="sync" @size="small" />
    </div>
  {{/if}}

  {{#if @isVisible}}
    <PrismButton
      @icon="sync"
      @isDisabled={{@isDayLiveupdateLimitReached}}
      @isSmall={{true}}
      @onClick={{@startDayLiveupdate}}
    />
  {{/if}}
</template> satisfies TOC<GeneralButtonsButtonDayLiveshopSignature>;

export default GeneralButtonsButtonDayLiveshop;
